import {
  SET_PROJECTS,
  SET_DOMAINS,
  NEW_DOMAIN,
  NEW_DOMAIN_ERROR,
  FILTER_DOMAINS,
  EDIT_DOMAIN,
  FORM_DATA,
  FORM_ERROR,
} from "../types";

const DomainReducer = (state, action) => {
  switch (action.type) {
    case SET_PROJECTS:
      return { ...state, projects: action.payload };

    case SET_DOMAINS:
      return { ...state, domains: action.payload };

    case NEW_DOMAIN:
      return { ...state, new_domain: action.payload };

    case NEW_DOMAIN_ERROR:
      return { ...state, new_domain_error: action.payload };

    case FILTER_DOMAINS:
      return {
        ...state,
        search_domain: action.payload,
        domains_filtered: state.domains.filter((domain) => {
          const regex = new RegExp(`${action.payload}`, "gi");
          return domain.name.match(regex);
        }),
      };

    case EDIT_DOMAIN:
      return {
        ...state,
        selected_index: action.payload.index,
        selected_domain: action.payload.domain,
      };

    case FORM_DATA:
      return { ...state, form_data: action.payload };

    case FORM_ERROR:
      return { ...state, form_error: action.payload };

    default:
      return state;
  }
};

export default DomainReducer;